import axios from 'axios';
import Deco from "security/decrypt"
import authHeader from './auth-header';

const API_URL = `${process.env.REACT_APP_MY_HOST}/v7/admin`;
const FORWARD_API_URL = `${process.env.REACT_APP_FORWARD_HOST}/v7/admin`;
const FORWARD_API_URL_2 = `${process.env.REACT_APP_FORWARD_HOST3}/v7/admin`;

const CHUNK_SIZE = 50 * 1024 * 1024; // 50MB per chunk

class UpdateService {

	getUpdate(tool) {
		return axios.get(`${API_URL}/update/${tool}`, { headers: authHeader() });
	}

	getUpdateAllServers(tool) {
		const headers = { headers: authHeader() };
		return Promise.allSettled([
			axios.get(`${API_URL}/update/${tool}`, headers).catch(e => e),
			axios.get(`${FORWARD_API_URL}/update/${tool}`, headers).catch(e => e),
			axios.get(`${FORWARD_API_URL_2}/update/${tool}`, headers).catch(e => e),
		]);
	}

	postUpdate(tool, version, log, selectedFile, onUploadProgressForward, onUploadProgressCurrent, onUploadProgressForward2) {
		const user = JSON.parse(Deco(localStorage.getItem('user')));
		if (!user || !user.token) return;

		const headers = {
			"Content-Type": "multipart/form-data",
			"Authorization": 'Bearer ' + user.token
		};

		const extraFields = { version, log };

		const requestForward = this._uploadToServer(
			`${FORWARD_API_URL}/update/${tool}`, selectedFile, extraFields, headers, onUploadProgressForward
		);
		const requestCurrent = this._uploadToServer(
			`${API_URL}/update/${tool}`, selectedFile, extraFields, headers, onUploadProgressCurrent
		);
		const requestForward2 = this._uploadToServer(
			`${FORWARD_API_URL_2}/update/${tool}`, selectedFile, extraFields, headers, onUploadProgressForward2
		);

		return [requestForward, requestCurrent, requestForward2];
	}

	putUpdate(id, tool, version, log, url_v2) {
		const headers = { headers: authHeader() };
		const data = { version, log, url_v2 };
		return Promise.any([
			axios.put(`${API_URL}/update/${tool}/${id}`, data, headers),
			axios.put(`${FORWARD_API_URL}/update/${tool}/${id}`, data, headers),
			axios.put(`${FORWARD_API_URL_2}/update/${tool}/${id}`, data, headers),
		]);
	}

	deleteUpdate(tool, id, filename) {
		const headers = { headers: authHeader() };
		const url = (base) => `${base}/update/${tool}/${id}?filename=${filename}`;
		return Promise.allSettled([
			axios.delete(url(API_URL), headers).catch(e => e),
			axios.delete(url(FORWARD_API_URL), headers).catch(e => e),
			axios.delete(url(FORWARD_API_URL_2), headers).catch(e => e),
		]);
	}



	getPlugin(tool) {
		return axios.get(`${API_URL}/plugin/${tool}`, { headers: authHeader() });
	}

	postPlugin(tool, type, localPath, selectedFile, onUploadProgressForward, onUploadProgressCurrent, onUploadProgressForward2) {
		// "Chọn từ server" → gửi JSON (không có file)
		if (type === "Chọn từ server") {
			const formData = { type, file: selectedFile, localPath };
			const user = JSON.parse(Deco(localStorage.getItem('user')));
			if (!user || !user.token) return;

			const headers = {
				"Content-Type": "application/json",
				"Authorization": 'Bearer ' + user.token
			};

			const makeReq = (url) => axios({ method: "post", url, data: formData, headers, timeout: 600000 });
			return [
				makeReq(`${FORWARD_API_URL}/plugin/${tool}`),
				makeReq(`${API_URL}/plugin/${tool}`),
				makeReq(`${FORWARD_API_URL_2}/plugin/${tool}`),
			];
		}

		// "Tải lên file" → chunked upload
		const user = JSON.parse(Deco(localStorage.getItem('user')));
		if (!user || !user.token) return;

		const headers = {
			"Content-Type": "multipart/form-data",
			"Authorization": 'Bearer ' + user.token
		};

		const extraFields = { type, localPath };

		return [
			this._uploadToServer(`${FORWARD_API_URL}/plugin/${tool}`, selectedFile, extraFields, headers, onUploadProgressForward),
			this._uploadToServer(`${API_URL}/plugin/${tool}`, selectedFile, extraFields, headers, onUploadProgressCurrent),
			this._uploadToServer(`${FORWARD_API_URL_2}/plugin/${tool}`, selectedFile, extraFields, headers, onUploadProgressForward2),
		];
	}

	deletePlugin(tool, id, filename) {
		const headers = { headers: authHeader() };
		const url = (base) => `${base}/plugin/${tool}/${id}?filename=${filename}`;
		return Promise.allSettled([
			axios.delete(url(API_URL), headers).catch(e => e),
			axios.delete(url(FORWARD_API_URL), headers).catch(e => e),
			axios.delete(url(FORWARD_API_URL_2), headers).catch(e => e),
		]);
	}




	getDll(tool) {
		return axios.get(`${API_URL}/dll/${tool}`, { headers: authHeader() });
	}

	postDll(tool, type, localPath, selectedFile, onUploadProgressForward, onUploadProgressCurrent, onUploadProgressForward2) {
		// "Chọn từ server" → gửi JSON (không có file)
		if (type === "Chọn từ server") {
			const formData = { type, file: selectedFile, localPath };
			const user = JSON.parse(Deco(localStorage.getItem('user')));
			if (!user || !user.token) return;

			const headers = {
				"Content-Type": "application/json",
				"Authorization": 'Bearer ' + user.token
			};

			const makeReq = (url) => axios({ method: "post", url, data: formData, headers, timeout: 600000 });
			return [
				makeReq(`${FORWARD_API_URL}/dll/${tool}`),
				makeReq(`${API_URL}/dll/${tool}`),
				makeReq(`${FORWARD_API_URL_2}/dll/${tool}`),
			];
		}

		// "Tải lên file" → chunked upload
		const user = JSON.parse(Deco(localStorage.getItem('user')));
		if (!user || !user.token) return;

		const headers = {
			"Content-Type": "multipart/form-data",
			"Authorization": 'Bearer ' + user.token
		};

		const extraFields = { type, localPath };

		return [
			this._uploadToServer(`${FORWARD_API_URL}/dll/${tool}`, selectedFile, extraFields, headers, onUploadProgressForward),
			this._uploadToServer(`${API_URL}/dll/${tool}`, selectedFile, extraFields, headers, onUploadProgressCurrent),
			this._uploadToServer(`${FORWARD_API_URL_2}/dll/${tool}`, selectedFile, extraFields, headers, onUploadProgressForward2),
		];
	}

	putPlugin(tool, id, newPath, url_v2) {
		const headers = { headers: authHeader() };
		const data = { path: newPath, url_v2 };
		return Promise.any([
			axios.put(`${API_URL}/plugin/${tool}/${id}`, data, headers),
			axios.put(`${FORWARD_API_URL}/plugin/${tool}/${id}`, data, headers),
			axios.put(`${FORWARD_API_URL_2}/plugin/${tool}/${id}`, data, headers),
		]);
	}

	deleteDll(tool, id, filename) {
		const headers = { headers: authHeader() };
		const url = (base) => `${base}/dll/${tool}/${id}?filename=${filename}`;
		return Promise.allSettled([
			axios.delete(url(API_URL), headers).catch(e => e),
			axios.delete(url(FORWARD_API_URL), headers).catch(e => e),
			axios.delete(url(FORWARD_API_URL_2), headers).catch(e => e),
		]);
	}

	putDll(tool, id, newPath, url_v2) {
		const headers = { headers: authHeader() };
		const data = { path: newPath, url_v2 };
		return Promise.any([
			axios.put(`${API_URL}/dll/${tool}/${id}`, data, headers),
			axios.put(`${FORWARD_API_URL}/dll/${tool}/${id}`, data, headers),
			axios.put(`${FORWARD_API_URL_2}/dll/${tool}/${id}`, data, headers),
		]);
	}



	// dev.dhbtools.com (explorer)
	getExplorerFiles(folder) {
		return axios.get(`${API_URL}/explorer?folder=${folder}`, { headers: authHeader() });
	}

	/**
	 * Upload file đến 1 server. Tự động chia chunks nếu file > 50MB.
	 * @param {string} url - URL endpoint
	 * @param {File} file - File object
	 * @param {object} extraFields - Các fields bổ sung (version, log, type, localPath...)
	 * @param {object} headers - Headers cho request
	 * @param {function} onProgress - Callback progress (compatible với axios onUploadProgress)
	 * @returns {Promise} - Promise resolve response cuối cùng
	 */
	_uploadToServer(url, file, extraFields, headers, onProgress) {
		const totalSize = file.size;

		// === FILE NHỎ (≤ 50MB) → Upload bình thường ===
		if (totalSize <= CHUNK_SIZE) {
			const formData = new FormData();
			formData.append("file", file);
			Object.entries(extraFields).forEach(([key, val]) => {
				if (val !== undefined && val !== null) formData.append(key, val);
			});

			return axios({
				method: "post",
				url,
				data: formData,
				headers,
				timeout: 600000,
				onUploadProgress: onProgress
			});
		}

		// === FILE LỚN (> 50MB) → Chunked upload ===
		const totalChunks = Math.ceil(totalSize / CHUNK_SIZE);
		const uploadId = `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

		return new Promise(async (resolve, reject) => {
			try {
				let lastResponse = null;

				for (let i = 0; i < totalChunks; i++) {
					const start = i * CHUNK_SIZE;
					const end = Math.min(start + CHUNK_SIZE, totalSize);
					const chunk = file.slice(start, end);

					const chunkFormData = new FormData();
					chunkFormData.append("file", chunk, file.name);
					chunkFormData.append("uploadId", uploadId);
					chunkFormData.append("chunkIndex", i.toString());
					chunkFormData.append("totalChunks", totalChunks.toString());
					chunkFormData.append("fileName", file.name);

					// Thêm extraFields vào mỗi chunk (server cần ở chunk cuối)
					Object.entries(extraFields).forEach(([key, val]) => {
						if (val !== undefined && val !== null) chunkFormData.append(key, val);
					});

					const completedBytes = i * CHUNK_SIZE;

					lastResponse = await axios({
						method: "post",
						url,
						data: chunkFormData,
						headers: { ...headers },
						timeout: 600000,
						onUploadProgress: (progressEvent) => {
							if (onProgress) {
								// Tính progress tổng: (chunks đã xong + chunk hiện tại) / tổng file
								const totalLoaded = completedBytes + progressEvent.loaded;
								onProgress({
									loaded: totalLoaded,
									total: totalSize,
									lengthComputable: true
								});
							}
						}
					});
				}

				resolve(lastResponse);
			} catch (err) {
				reject(err);
			}
		});
	}
}

export default new UpdateService();
